import { render, staticRenderFns } from "./eye-color.vue?vue&type=template&id=c81b7806&scoped=true"
import script from "./eye-color.vue?vue&type=script&lang=ts"
export * from "./eye-color.vue?vue&type=script&lang=ts"
import style0 from "./eye-color.vue?vue&type=style&index=0&id=c81b7806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81b7806",
  null
  
)

export default component.exports